import { render, staticRenderFns } from "./SigaInstanceRegister.vue?vue&type=template&id=003791bf"
import script from "./SigaInstanceRegister.vue?vue&type=script&lang=js"
export * from "./SigaInstanceRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports